import script from "./CabeceraJugador.vue?vue&type=script&setup=true&lang=ts"
export * from "./CabeceraJugador.vue?vue&type=script&setup=true&lang=ts"

import "./CabeceraJugador.vue?vue&type=style&index=0&id=130217f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130217f4"]])

export default __exports__